module.exports = __webpack_public_path__ + "assets/img/whatsap-qr-code.ee3b5138.svg";